import React ,{ useState, useEffect,useRef } from 'react'
import '../Css/Services.css';
import { faAngleRight, faCircleDot, faList,faTag,faCalendarCheck,faLocationDot, faHammer, faW, faWrench,faBusinessTime,faLadderWater} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock,faPlug,faCouch,faShower,faScrewdriver,faDoorOpen,faPaintRoller,faPen,faRuler,faRulerHorizontal,faWindows } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
// 1. Import Helmet from react-helmet-async
import { Helmet } from 'react-helmet-async';


const cookies = new Cookies;

function Services() {
    const navigate = useNavigate();

    //create a option object
    let Option1 = useRef(null);
    let Option2 = useRef(null);
    let Option3= useRef(null);
    let Option4 = useRef(null);
    let Option5 = useRef(null);
    let Option6 = useRef(null);
    let Option7 = useRef(null);
    let Option8 = useRef(null);
    let Option9 = useRef(null);
    let Option10 = useRef(null);
    let Option11 = useRef(null);
    //新加: 冷氣安裝及維修,商業維修
    let Option12 = useRef(null);
    let Option13 = useRef(null);

    const handleRegistry = (e, select) => {
        let orderType;
        orderType = select;
        cookies.set("orderType", orderType);
        console.log("OrderType:", orderType);
        navigate('/ServiceForm');
    }    

  

    return (
        <div>
            <Helmet>
                <title>在線預約家居維修服務 | 維修王：免下載 App 快速報價配對</title>
                <meta name="description" content="不想安裝 App？透過維修王網頁版即可免費申請水電維修、冷氣清洗、油漆翻新等服務。簡單填寫需求，專業師傅主動報價。" /> 
                <meta property="og:title" content="免下載 App！網上填表即找專業維修師傅" />
                <meta property="og:description" content="維修需求急？簡單三步提交申請，全港持牌師傅為你效勞。" />
                <meta property="og:image" content="https://homerepairexperthk.com" />
                <meta property="og:url" content="https://homerepairexperthk.com" />
            </Helmet>
            
            <div className="Services-Wrapper">
            <div className="Services-Content">
                <div className="Services-Body">
                    <div className="Services-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;選擇維修項目</div>  
                    <div className="Services-Body-Context">
                        <div className="Services-Selection-Content">
                        <ul>
                            <li ref={Option1} onClick={(e) => {handleRegistry(e,0)}}><FontAwesomeIcon icon={faPlug} />&nbsp;&nbsp;電力維修</li>
                            <li ref={Option2} onClick={(e) => { handleRegistry(e, 1) }}><FontAwesomeIcon icon={faShower} />&nbsp;&nbsp;水喉維修</li>
                            <li ref={Option3} onClick={(e) => { handleRegistry(e, 2) }}><FontAwesomeIcon icon={faLock} />&nbsp;&nbsp;門銷維修</li>
                            <li ref={Option4} onClick={(e) => { handleRegistry(e, 3) }}><FontAwesomeIcon icon={faScrewdriver} />&nbsp;&nbsp;鋁窗維修</li>
                            <li ref={Option5} onClick={(e) => { handleRegistry(e, 4) }}><FontAwesomeIcon icon={faDoorOpen} />&nbsp;&nbsp;木門/閘門維修</li>
                            <li ref={Option6} onClick={(e) => { handleRegistry(e, 5) }}><FontAwesomeIcon icon={faCouch} />&nbsp;&nbsp;家具及家俬安裝</li>
                            <li ref={Option7} onClick={(e) => { handleRegistry(e, 6) }}><FontAwesomeIcon icon={faPaintRoller} />&nbsp;&nbsp;油漆</li>
                            <li ref={Option8} onClick={(e) => { handleRegistry(e, 7) }}><FontAwesomeIcon icon={faRulerHorizontal} />&nbsp;&nbsp;地板安裝/維修</li>
                            <li ref={Option9} onClick={(e) => { handleRegistry(e, 8) }}><FontAwesomeIcon icon={faRuler} />&nbsp;&nbsp;石屎剥落</li>
                            <li ref={Option10} onClick={(e) => { handleRegistry(e, 9) }}><FontAwesomeIcon icon={faHammer} />&nbsp;&nbsp;裝修工程</li>    
                            <li ref={Option11} onClick={(e) => { handleRegistry(e, 10) }}><FontAwesomeIcon icon={faWrench} />&nbsp;&nbsp;驗窗</li>        
                            <li ref={Option12} onClick={(e) => { handleRegistry(e, 11) }}><FontAwesomeIcon icon={faLadderWater} />&nbsp;&nbsp;冷氣安裝及維修</li>        
                            <li ref={Option13} onClick={(e) => { handleRegistry(e, 12) }}><FontAwesomeIcon icon={faBusinessTime} />&nbsp;&nbsp;商業維修</li>            
                        </ul>
                        
                        </div>        
                    </div>
                </div>        
            </div>
            </div>      
        </div>          
  )
}

export default Services
